export function initCartModal() {
    const modal = document.querySelector('[data-cart-modal]');
    if (!modal) return;

    const productEl = modal.querySelector('[data-cart-modal-product]');
    const cartBtn = modal.querySelector('[data-cart-modal-cart]');
    const closeEls = modal.querySelectorAll('[data-cart-modal-close]');
    const config = window.webAudityCart || {};

    if (cartBtn && config.cartUrl) {
        cartBtn.href = config.cartUrl;
    }

    const openModal = (productName = '') => {
        if (productEl) {
            productEl.textContent = productName;
            productEl.hidden = !productName;
        }

        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-lock');

        requestAnimationFrame(() => {
            modal.classList.add('is-open');
        });

        cartBtn?.focus();
    };

    const closeModal = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-lock');

        window.setTimeout(() => {
            if (!modal.classList.contains('is-open')) {
                modal.hidden = true;
            }
        }, 300);
    };

    closeEls.forEach((el) => {
        el.addEventListener('click', (event) => {
            event.preventDefault();
            closeModal();
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
        }
    });

    if (!window.jQuery) return;

    const $ = window.jQuery;

    $(document.body).on('added_to_cart', (event, fragments, cartHash, $button) => {
        $('.audits .added_to_cart').remove();

        let productName = '';

        if ($button && $button.length) {
            productName = $button.closest('.audit-card').find('.audit-card__title').first().text().trim();
        }

        openModal(productName);
    });
}
